<template>
	<div class="main">
		<div class="cpqk">
			<div class="cpqk-left">
				会员之家
			</div>
			<div class="cpqk-right">

			</div>
		</div>
		<div class="hyzj-js">
			<p>
				一、宗旨
			</p>
			<p style="text-indent: 2em;">
				博物馆之友会员由普通会员、高级会员和VIP会员组成，个人和集体均可参加。旨在面向校内外征集有关、发展和建设的史料和实物，向社会推介博物馆的展览并及时反馈意见及要求，了解社会动态和信息，帮助博物馆开展业务工作，增强博物馆的社会基础。
			对本馆有特殊贡献者，可成为VIP会员，享受高级会员的全部权利，并可享有：
			</p>
			<p style="text-indent: 4em;">
				1、受邀出席重要展览的开幕式。
			</p>
			<p style="text-indent: 4em;">
				2、个人撰写的有关文献资料，经审定可在本馆网站上发布。
			</p>
			<p>
				二、会员义务
			</p>
			<p style="text-indent: 4em;">
				1、自觉遵守博物馆的相关规章制度。
			</p>
			<p style="text-indent: 4em;">
				2、致力于博物馆的发展，宣传博物馆文化。
			</p>
			<p style="text-indent: 4em;">
				3、协助博物馆组织临时展览、征集文物、开展文物鉴赏、文博研讨等业务活动。
			</p>
			<p>
				三、在线注册
			</p>
			<p style="text-indent: 4em;">
				1、普通会员需在线实名注册，经审核后获批。
			</p>
			<p style="text-indent: 4em;">
				2、高级会员需在线实名注册，并提交本馆颁发的捐赠证书电子版，经审核后获批。
			</p>
			<p style="text-indent: 4em;">
				3、VIP会员由本馆向符合条件的人士发出入会邀请，暂不接受主动报名
			</p>
		</div>
		<div class="hyzj-news-block">
			<div class="hyzj-news-list">
				<div class="hyzj-news-box" v-for="(item, index) in dataList" :key="index" @click="toDetails(item.id)">
					<div class="news-left">
						<img :src="$imgUrl + item.listImgPc" alt="">
					</div>
					<div class="news-right">
						<div class="news-title">
							{{item.title}}
						</div>
						<div class="news-content">
							{{item.shortTitle}}
						</div>
						<div class="news-time">
							{{$moment(item.createdTime).format('YYYY-MM-DD')}}
						</div>
					</div>
				</div>
			</div>
			<page :pageObj="params" @getDataList="getData"></page>
		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			Page
		},
		data () {
			return {
				params: {
					current: 1,
					size: 6,
					channelId: this.$store.state.channelId,
					releaseTerrace: "releasePc"
				},
				dataList: []
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_2.png'
		},
		methods: {
			getData(dataList) {
				this.dataList = dataList
			},
			toDetails(news_id) {
				this.$router.push({
					path: '/hyzj_details',
					query: {
						news_id: news_id
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.main {
		width: 74%;
		margin: 18px 13% 80px;
		font-size: 12px;
		color: #333333;
		.cpqk {
			text-align: left;
			display: flex;
			height: 30px;
			line-height: 30px;
			justify-content: space-between;
			.cpqk-left {
				color: #264EA7;
				font-size: 13px;
				margin-right: 10px;
				width: 6%;
			}
			.cpqk-right {
				height: 16px;
				width: 94%;
				border-bottom: 2px solid #EDD68E;
			}
		}
		.hyzj-js {
			text-align: left;
			font-size: 12px;
			color: #686868;
			margin: 10px;
			line-height: 22px;
		}
		.hyzj-news-block {
			margin: 30px 0 40px;
			.hyzj-news-list {
				margin-bottom: 20px;
				.hyzj-news-box {
					display: flex;
					justify-content: space-between;
					width: 100%;
					padding: 20px;
					margin: 0 0 20px;
					border-bottom: 1px solid #B4B4B4;
					cursor: pointer;
					.news-left {
						width: 25%;
						img {
							width: 100%;
							height: 100%;
						}
					}
					.news-right {
						width: 70%;
						text-align: left;
						.news-title {
							color: #264EA7;
							font-size: 12px;
							height: 30px;
							line-height: 30px;
						}
						.news-content {
							margin-top: 15px;
							color: #686868;
							font-size: 9px;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							line-clamp: 2;
							-webkit-box-orient: vertical;
						}
						.news-time {
							margin-top: 10px;
							color: #686868;
							font-size: 9px;
						}
					}
				}
				.hyzj-news-box:hover {
					display: flex;
					justify-content: space-between;
					width: 100%;
					padding: 20px;
					margin: 0 0 20px;
					border: 1px solid #EDD68E;
					cursor: pointer;
					.news-left {
						width: 25%;
						img {
							width: 100%;
							height: 100%;
						}
					}
					.news-right {
						width: 70%;
						text-align: left;
						.news-title {
							color: #264EA7;
							font-size: 12px;
							height: 30px;
							line-height: 30px;
						}
						.news-content {
							margin-top: 15px;
							color: #686868;
							font-size: 9px;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							line-clamp: 2;
							-webkit-box-orient: vertical;
						}
						.news-time {
							margin-top: 10px;
							color: #686868;
							font-size: 9px;
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/visit_service/hyzj.vue